import { gql } from '@apollo/client'
import { head } from 'ramda'
import React from 'react'

import { generalClient } from '../../../../../utils/apollo/api'
import StatePresenter from '../../../../../packages/kiti/components/helpers/StatePresenter'
import { useQuery } from '../../../../../utils/apollo/_helpers/useQuery'

const NAME = 'automatic_service_orders_distribution'

const Context = React.createContext([])
const { Provider } = Context
export const useConfigState = () => React.useContext(Context)
export const useConfig = () => useConfigState()?.config

const QUERY = gql`
  query Configs($name: String) {
    configs(filter: { name: $name }) {
      id
      name
      value
      enabled
      updatedAt
      insertedAt
    }
  }
`

const ConfigsLoader = ({ children }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: { name: NAME },
    client: generalClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={{ ...data, config: data?.configs || [] }}>{children}</Provider>
    </StatePresenter>
  )
}

export default ConfigsLoader
